import {Component, OnInit} from '@angular/core';
import {StateService} from "@uirouter/core";

import {
    AppAlertService,
    ParametersService,
    SubtitlesService,
    ZonesService
} from "../../core";
import {ZoneViewData} from "../../models";

@Component({
    selector: 'constant-temp',
    templateUrl: './constant-temp.component.html',
    styleUrls: ['./constant-temp.component.scss']
})
export class ConstantTempComponent implements OnInit {
    initZoneSetTemperature: number = 0;

    constructor(
        private appAlert: AppAlertService,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public zones: ZonesService,
    ) {
    }

    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }
        this.checkSelectedZone();
        this.zones.setOverflow();
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }

    checkSelectedZone() {
        const selectedZone = this.zones.selectedZone as ZoneViewData;
        if (selectedZone) {
            this.initZoneSetTemperature = selectedZone.mode.setTemperature;
        }
    }

    sendConstantTemp(): void{
        if (this.parameters.demoAccount()) {
            this.appAlert.showAppAlert(this.subtitle(3529), this.subtitle(475), null, false, null);
            return;
        }
        this.zones.returnValue('constantTemp');
    }
}
